/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../../common/components/layout/Layout';
import Header from '../../../../../common/components/layout/Header';
import PaymentLabels from '../../../../../common/components/modules/sports/PaymentLabelsLeft';
import Button from '../../../../../common/components/sections/Button';
import LayoutInside from '../../../../../common/components/layout/LayoutInside';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../../../context/auth-context';
import { useDispatch, useSelector } from 'react-redux';
import { getSlotPrices } from '../../../../../modules/sport/actions/reducerPrices';
import { createReservation, resetReservation } from '../../../../../modules/sport/actions/reducerReservations';
import { IPriceRent } from '../../../../../modules/sport/interfaces/field';
import Loading from '../../../../../common/loading/Loading';
import { attributesBySport } from '../../../../../common/data/attributes';
import { formatPrice } from '../../../../../utils';
import MsjSuccess from '../../../../../common/components/sections/MsjSuccessDefy';
import { resetDefyReset, resetStateDefyResponse } from '../../../../../modules/sport/actions/reducerDefy';
import { teamProfileGet } from '../../../../../modules/sport/actions/reducerTeam';
import { ITeam } from '../../../../../modules/sport/interfaces/game';
import FormCreateTeam from '../../../../../common/components/sections/FormCreateTeam';
import Image from '../../../../../common/Image';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const confirmDefy = (): JSX.Element => {
    const attribute = attributesBySport('defy');
    const auth = useAuth();
    const location = useLocation();
    const dispatch = useDispatch();

    const selectReservations = (state: any) => state.reservations;
    const reservations = useSelector(selectReservations);

    const selectListPrices = (state: any) => state.priceState;
    const priceState = useSelector(selectListPrices);

    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const query = useQuery();
    const title = query.get('title');
    const nameUrl = query.get('name');
    const emailUrl = query.get('email');
    const phoneUrl = query.get('phone');
    const date = query.get('date');
    const start = query.get('start');
    const end = query.get('end');
    const fieldName = query.get('fieldName');
    const price = query.get('price');
    const club = query.get('club');
    const field = query.get('field');
    const dateEnd = query.get('dateEnd');
    const dateStart = query.get('dateStart');
    const nameClub = query.get('nameClub');
    const slot = query.get('slot');
    const fieldId = query.get('fieldId');
    const address = query.get('address');
    const capacityField = query.get('capacity');
    const challengedTeamId = query.get('challengedTeamId').trim();
    const challengedTeamName = query.get('challengedTeamName');
    const [error, setError] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [priceRent, setPriceRent] = useState<IPriceRent>();
    const [isRedirecting, setIsRedirecting] = useState(false);
    const pathnameAll = window.location.pathname + useLocation().search;
    const [deposit, setDeposit] = useState<number>();
    const [msj, setMsj] = useState<string>('');
    const [statusReservations, setStatusReservations] = useState(false);
    const inputRefButton = useRef<HTMLDivElement>();
    const search = useLocation().search;
    const router = useHistory();
    const selectTeam = (state: any) => state.team;
    const team = useSelector(selectTeam);
    const [openModalTeam, setOpenModalTeam] = useState(false);
    const [dataTeamOri, setdataTeamOri] = useState<ITeam>();
    const [capacity, setCapacity] = useState<string>('');

    const breads = [
        {
            key: 'sport',
            name: 'Equipos | Buscar',
            url: `/desafiar`,
            add: true,
        },
        {
            key: 'team-create',
            name: 'Desafío | Crear',
            url: `/desafiar/equipos/crear${search}`,
            add: true,
        },
        {
            key: 'reservar',
            name: 'Reservar',
            url: `/desafiar/reservar/filter${search}`,
            add: true,
        },
        {
            key: 'confirm',
            name: 'Confirmar',
            url: pathnameAll,
            add: false,
        },
    ];

    const filter = {
        sport,
        emailUrl,
        phoneUrl,
        date,
        start,
        nameUrl,
        end,
        fieldName,
        price,
        field,
        club,
        slot,
        title,
        dateStart,
        dateEnd,
        fieldId,
        address,
        challengedTeamId,
        challengedTeamName,
    };

    useEffect(() => {
        //console.log('reservations:', reservations);
        if (reservations.isLoading) {
            // console.log('reservacion cargando');
        }
        if (reservations.error) {
            //  console.log('reservacion error:', reservations.error);
            setError('Error al Crear la reservación, intente más tarde');
        }
        if (!reservations.isLoading && reservations?.data?.statusCode === 'RESERVATION_CREATED') {
            setStatusReservations(true);
            dispatch(resetStateDefyResponse());
            dispatch(resetDefyReset());
            //aqui
            if (reservations.data.data.challengeId) {
                const search = `?challengeId=${reservations.data.data.challengeId}`;
                router.push({
                    pathname: `/${sport}/desafiar/equipo/filter`,
                    search: search,
                });
            }
        }
    }, [reservations]);

    useEffect(() => {
        if (price) {
            setStatusReservations(false);
            dispatch(getSlotPrices({ pricesId: price, clubId: club, calculateFor: 'challenge' }));
        }
    }, [price]);

    useEffect(() => {
        if (team) {
            //console.log({ team });
            if (team.error) {
                setError('Error al obtener el Equipo del usuario');
            } else {
                if (team.data && team.data.data && team.data.statusCode === 'USER_PROFILE_TEAM_GETED') {
                    const dataTeam = team.data.data;
                    setdataTeamOri(dataTeam);
                    //aqui valido si updateTeamProfile viene en falso no tiene nombre de equipo, se activa el formulario para crearlo
                    if (!dataTeam.updatedTeamProfile) {
                        setOpenModalTeam(true);
                    } else {
                        setOpenModalTeam(false);
                    }
                }
            }
        }
    }, [team]);

    useEffect(() => {
        if (priceState && priceState.data && priceState.data.data && priceState.data.data.length >= 0) {
            setPriceRent(priceState.data.data[0]);
        }
    }, [priceState]);

    useEffect(() => {
        if (priceRent) {
            if (
                priceRent.paymentMethods &&
                priceRent.paymentMethods.code &&
                priceRent.paymentMethods.code === 'DEPOSIT' &&
                priceRent.discountPercentage > 0
            ) {
                const total = priceRent.discountPercentage;
                if (total && total > 0) {
                    setMsj(`Debes abonar ${formatPrice(total, 0)}, y el resto cancelarlo en la cancha`);
                }

                setDeposit(total);
            } else {
                setDeposit(priceRent.basePrice);
            }
        }
    }, [priceRent]);

    useEffect(() => {
        setError('');
        dispatch(resetReservation());
        dispatch(teamProfileGet(sport));
        if (auth && auth.isLoggedIn && auth.user) {
            setName(auth.user.firstName + ' ' + auth.user.lastName);
            setEmail(auth.user.email);
            setPhone(auth.user.phone ? auth.user.phone : '');
        }
        const capacityTeam = capacityField !== '' ? Math.round(parseInt(capacityField) / 2) : '';
        setCapacity(` ${capacityTeam}x${capacityTeam} `);
    }, [auth]);

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        setError('');
        setIsRedirecting(true);
        // console.log('aquil llegue:', challengedTeamId);
        const paymentMethodId = priceRent.paymentMethods?.id;
        const payload = {
            start: filter.dateStart,
            end: filter.dateEnd,
            fieldId: filter.fieldId,
            priceId: priceRent && priceRent.id,
            methodsId: paymentMethodId,
            challengeType: challengedTeamId && challengedTeamId !== '' ? 'DIRECT' : 'OPEN',
            challengedTeamId: challengedTeamId && challengedTeamId !== '' ? challengedTeamId : '',
        };
        //  console.log('aquil llegue:', payload, error);
        if (!error) {
            dispatch(createReservation(payload));
        }
    };

    return (
        <Layout navProps={{ title: 'Pago Arriendo | Supermatch', description: 'Desafíar Supermatch' }}>
            <>
                <Header />
                <LayoutInside
                    attribute={attribute}
                    title={`Confirmar Desafío ${capacity} en Club ${nameClub}`}
                    breads={breads}
                >
                    <>
                        {error && (
                            <div className="flex flex-col mx-auto w-full md:w-1/3 mb-2 text-center  font-bold">
                                <p className="w-full my-6 text-red-500">*{error}</p>
                            </div>
                        )}
                        {msj && (
                            <div className="flex flex-col mx-auto w-full md:w-1/3 mb-2 text-center  font-bold">
                                <p className="w-full text-xl my-6 text-green-500">{msj}</p>
                            </div>
                        )}
                        {!statusReservations && !openModalTeam ? (
                            <>
                                <div className="w-full md:w-3/5 lg:w-1/2 mx-auto flex-none md:flex  py-4 md:py-6 md:px-16 border-2 bg-white shadow-lg rounded-xl">
                                    <div className="w-full md:w-2/3 px-4 md:px-0 pb-10 md:pb-0 ">
                                        <PaymentLabels
                                            title="Fecha"
                                            icon="date"
                                            value={`${filter.date}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Desde"
                                            icon="time"
                                            value={`${filter.start} Hrs -  ${filter.end} Hrs`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Cancha"
                                            icon="field"
                                            value={filter.fieldName}
                                            sport={sport}
                                        />
                                        <PaymentLabels title="Lugar" icon="club" value={`${nameClub}`} sport={sport} />
                                        <PaymentLabels
                                            title="Dirección"
                                            icon="location"
                                            value={`${filter.address || ''}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels title="Nombre" icon="user" value={`${name}`} sport={sport} />
                                        <PaymentLabels title="Email" icon="email" value={`${email}`} sport={sport} />
                                        {phone && (
                                            <PaymentLabels title="Teléfono" icon="phone" value={phone} sport={sport} />
                                        )}
                                        {!priceState.isLoading && priceRent && priceRent.basePrice && (
                                            <PaymentLabels
                                                title="Total"
                                                icon="pay"
                                                value={`${formatPrice(priceRent.basePrice, 0)}`}
                                                sport={sport}
                                            />
                                        )}
                                    </div>
                                    <div className="w-full md:w-2/6 text-center justify-center content-center">
                                        <h3 className="text-xl font-bold italic text-sm-blue-primary pb-4">
                                            {priceRent.discountPercentage > 0
                                                ? 'Abono a pagar por equipo'
                                                : 'Total a pagar por Equipo'}
                                        </h3>
                                        {priceState.isLoading && <Loading />}
                                        {!priceState.isLoading && deposit && (
                                            <div className="flex flex-col text-center justify-center content-center">
                                                <p className="text-4xl pt-4 font-bold italic text-sm-integrate">{`${formatPrice(
                                                    deposit / 2,
                                                    0,
                                                )}`}</p>
                                            </div>
                                        )}
                                        {dataTeamOri && dataTeamOri.updatedTeamProfile && (
                                            <div className="flex flex-col text-center justify-center content-center">
                                                <h3 className="text-2xl font-bold italic text-sm-rent pt-4 pb-4">
                                                    Equipo de {dataTeamOri.sport?.name}:
                                                </h3>
                                                <p className="text-4xl pt-4 font-bold italic text-sm-blue-primary ">
                                                    {dataTeamOri.name}
                                                </p>
                                            </div>
                                        )}

                                        {challengedTeamId !== '' && challengedTeamName !== '' && (
                                            <div className="flex flex-col text-center justify-center content-center items-center">
                                                {attribute && (
                                                    <Image
                                                        className="py-8"
                                                        src={attribute.icon.image}
                                                        alt={attribute.alt}
                                                        height={attribute.icon.height}
                                                        width={attribute.icon.width}
                                                    />
                                                )}
                                                <p className="text-4xl pt-4 font-bold italic text-sm-blue-primary ">
                                                    {challengedTeamName}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-col mx-auto w-full md:w-1/3 mt-6 mb-2" ref={inputRefButton}>
                                    <Button
                                        title={isRedirecting ? 'Espera un momento...' : 'Confirmar'}
                                        handlerClick={handleSubmit}
                                        disabled={isRedirecting || priceState.isLoading}
                                    />
                                </div>
                            </>
                        ) : (
                            !openModalTeam && (
                                <MsjSuccess challengeId={undefined}>
                                    <>
                                        <p className="pt-12 text-center text-2xl font-bold italic">
                                            Su Partido fue creado exitosamente
                                        </p>
                                        <p className="">_________________________</p>
                                        <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                            si algun equipo acepta el partido le enviaremos un correo para que realice
                                            el pago
                                        </p>
                                    </>
                                </MsjSuccess>
                            )
                        )}
                        {error && (
                            <div className="flex flex-col mx-auto w-full md:w-1/3 mt-2 mb-2 text-center  font-bold">
                                <p className="w-full my-6 text-red-500">*{error}</p>
                            </div>
                        )}
                        {openModalTeam && (
                            <FormCreateTeam
                                setOpenModalTeam={setOpenModalTeam}
                                setdataTeamOri={setdataTeamOri}
                                sport={sport}
                                team={team}
                            />
                        )}
                    </>
                </LayoutInside>
            </>
        </Layout>
    );
};

export default confirmDefy;
